//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import {
    BreadcrumbItemToggleMessage,
    IBreadcrumbItemModel,
    Messenger,
    NodeModel
} from '@app/shared';

import { PresenterType } from '@shared/components';

@PresenterType(
{
    model: NodeModel<IBreadcrumbItemModel>
})
@Component({
    selector: 'filter-item-template',
    templateUrl: './filter-item-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilterItemTemplateComponent
{
    public data: WritableSignal<NodeModel<IBreadcrumbItemModel>>;

    constructor(private messenger: Messenger) {
        this.data = signal<NodeModel<IBreadcrumbItemModel>>(null);
    }

    public toggleBreadcrumb(obj: IBreadcrumbItemModel) {
        this.messenger.send(new BreadcrumbItemToggleMessage(obj));
    }
}